import type { TokenStore } from './token-store.js'

/**
 * Whether the client currently holds a bearer token to authenticate with.
 *
 * This answers "should the app show the logged-in surface or the login form?" — not "is the token
 * still valid?". A stored JWT can still be expired or server-revoked; that is proven only on the
 * first authorized call (a `401` there clears the token and drops back to the login form). Keeping
 * the check purely local avoids a network round-trip on every boot against a domain that may be
 * mid-rotation.
 */
export const hasSession = async (store: TokenStore): Promise<boolean> => {
  const token = await store.load()
  return Boolean(token)
}
